export default function omitNewLines(string) {
  return string.replace(/\s+/g, ' ');
}
